import { observe, useObserver, viewportWidth } from 'react-ui-observer'
import styled, { css } from 'styled-components'

import { breakpoints } from 'bl-common/src/constants/breakpoints'
import { Type } from 'bl-common/src/elements/Typography/Typography'
import { Appear } from 'bl-common/src/units/Appear'
import { Carousel } from 'bl-common/src/units/Carousel/Carousel'
import { Section } from 'bl-common/src/units/Section/Section'
import { media } from 'bl-common/src/utils/media'

import { StoryCard } from './StoryCard'

const RecentFeaturesSection = styled(Section)`
  overflow-x: hidden;
`

const Container = styled.div`
  display: flex;
`

const Item = styled.div`
  flex: 1;
  &:not(:first-child) {
    margin-left: 40px;
  }
`

const Header = styled.header`
  margin-bottom: 32px;
  ${media.md(css`
    margin-bottom: ${({ theme }) => theme.spacing[2]};
  `)}
`

const StoryCarousel = ({ stories }) => (
  <Carousel renderControls={false} pageMargin={2}>
    {stories.slice(0, 4).map((story, index) => (
      <StoryCard
        key={index}
        imageRatio={0.8}
        title={story.fields.title}
        topic={story.fields.topic}
        date={story.fields.publishDate}
        image={story.fields.heroImage.fields.image}
        link={story.fields.slug}
      />
    ))}
  </Carousel>
)

export const RecentFeatures = ({ stories = [], top = {}, bottom = {} }) => {
  // TODO: Switch to useBreakpoints
  const isMobile = useObserver(
    observe(viewportWidth(), width => width < breakpoints.md)
  )

  return (
    <RecentFeaturesSection
      top={top}
      bottom={bottom}
      background={{
        color1: '#fdfcfb',
        color2: '#e2e5e7',
        degrees: '150deg',
      }}
    >
      <Header>
        <Type preset="headlineSmall">Recent features</Type>
      </Header>
      {isMobile ? (
        <StoryCarousel stories={stories} />
      ) : (
        <Appear observer>
          <Container>
            {stories.map(story => (
              <Item key={story.fields.title}>
                <StoryCard
                  isSmall
                  key={story.sys.id}
                  imageRatio={1.1}
                  title={story.fields.title}
                  topic={story.fields.topic}
                  date={story.fields.publishDate}
                  image={story.fields.heroImage.fields.image}
                  link={story.fields.slug}
                />
              </Item>
            ))}
          </Container>
        </Appear>
      )}
    </RecentFeaturesSection>
  )
}
